import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasAnyRole } from "../../utils/roles";

export default function PrivateRoute({ children, requiredRoles = [] }) {
    const { user: currentUser } = useSelector((state) => state.auth);
    const location = useLocation();

    if (!currentUser) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: `${location.pathname}${location.search}${location.hash}` }}
            />
        );
    }

    if (!hasAnyRole(currentUser.roles, requiredRoles)) {
        return <Navigate to="/" replace />;
    }

    return children;
}
